<template>
  <select
    :value="value"
    class="
      tw-form-input tw-block tw-w-full tw-shadow-sm
      focus:tw-ring-sp-blue-500 focus:tw-border-sp-blue-500
      sm:tw-text-sm
      tw-border-gray-300 tw-rounded-md tw-leading-4
      placeholder:tw-italic
      tw-placeholder-gray-400 tw-form-select
    "
    name="reviewers"
    data-testid="leave-review-reviewers-select"
    @change="handleChange"
  >
    <option
      v-for="reviewer in reviewers"
      :key="reviewer.user_id"
      class="formkit-option"
      :value="reviewer.user_id"
    >
      {{ reviewer.name }}
    </option>
  </select>
</template>

<script>
export default {
  name: 'LeaveReviewReviewersSelect',

  props: {
    value: {
      type: Number,
      default: null,
    },
    inspection: {
      type: Object,
      required: true,
    },
  },

  computed: {
    reviewers() {
      return []
        .concat(this.inspection.attributes.buyer?.data?.attributes || [])
        .concat(this.inspection.attributes.buyer_2?.data?.attributes || [])
        .concat(this.inspection.attributes.buying_agent?.data?.attributes || [])
    },
  },

  methods: {
    handleChange(event) {
      this.$emit('input', event.target.value)
    },
  },
}
</script>
